import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import styles from "./SimpleFormBlock.module.scss";
import { ValidatedInput } from "../../Input/ValidatedInput/ValidatedInput";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SimpleFormBlock = function SimpleFormBlock(_ref) {
  var headline = _ref.headline,
    textInput = _ref.textInput,
    formData = _ref.formData,
    wrapperClassName = _ref.wrapperClassName;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.wrapper, wrapperClassName),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [headline && headline.text && /*#__PURE__*/_jsx(HeadingText, {
        className: styles.headline,
        align: "left",
        ariaLevel: headline.ariaLevel || 2,
        typog: headline.typog,
        children: headline.text
      }), formData !== null && formData !== void 0 && formData.success ? /*#__PURE__*/_jsx(Text, {
        className: styles.success,
        typog: "bodycopyLarge",
        children: formData.successMessage
      }) : /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
        className: styles.input
      }, textInput))]
    })
  });
};